module.exports = __webpack_public_path__ + "static/img/4.10afdc9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/sp/4.png
// module id = sswd
// module chunks = 0